module.exports = __webpack_public_path__ + "static/media/smart_recruiters_icon.181f8922.png";